import { AlarmCategory } from '@core/referential/alarm-category.enum'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'

// `category` pre-expands the matching section (used by the detail-page breadcrumb).
export const SearchSchema = z.object({
  category: z.nativeEnum(AlarmCategory).optional(),
})

export type Search = z.infer<typeof SearchSchema>

export const Route = createFileRoute('/_dashboard/site/$id/alarms/')({
  validateSearch: SearchSchema,
  pendingComponent: PendingComponent,
})
